// Vendor Libs
import React, { useEffect } from 'react';
import PropTypes from 'prop-types'; // Dish Tech React

import { useOverlay } from '@dishtech-react/hooks'; // Material UI

import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles({
  dialog: {
    maxHeight: '90%',
    minHeight: '40%'
  },
  dialogContent: {
    overflow: 'visible'
  }
});
export var Overlay = function Overlay(_ref) {
  var children = _ref.children,
      closeOnBlur = _ref.closeOnBlur,
      wide = _ref.wide,
      id = _ref.id,
      title = _ref.title;
  var classes = useStyles();

  var _useOverlay = useOverlay({
    id: id
  }),
      closeOverlay = _useOverlay.closeOverlay,
      open = _useOverlay.open; // eslint-disable-next-line react-hooks/exhaustive-deps


  useEffect(function () {
    return closeOverlay;
  }, []);
  return /*#__PURE__*/React.createElement(Dialog, {
    className: classes.dialog,
    fullWidth: wide,
    maxWidth: wide ? 'lg' : undefined,
    open: open,
    onClose: closeOnBlur ? closeOverlay : undefined
  }, title && title.length ? /*#__PURE__*/React.createElement(DialogTitle, null, title) : null, /*#__PURE__*/React.createElement(DialogContent, {
    className: classes.dialogContent
  }, typeof children === 'function' ? children() : children));
};
Overlay.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  closeOnBlur: PropTypes.bool,
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  wide: PropTypes.bool
};
Overlay.defaultProps = {
  closeOnBlur: false,
  wide: false
};